import React from 'react';
import { RatioIframe } from './';

export const KijkEmbed = ({ id }) => (
  <RatioIframe
    src={`https://embed.kijk.nl/?token=mediahuis_dumpert_web&video=${id}`}
    allow='autoplay; encrypted-media; fullscreen'
    scrolling='no'
  />
);
